import React, { memo } from 'react';
import MDEditor from '@uiw/react-md-editor';

export default memo(
	function MarkdownEdit({ value, setValue }: { value?: string; setValue: (value?: string) => void }) {
		return <MDEditor data-color-mode='light' value={value} onChange={(value?: string) => setValue(value)} />;
	},
	(prevProps, nextProps) => prevProps.value === nextProps.value,
);
